import { inject, Injectable } from "@angular/core";
import { NavigationService } from "@tylertech/core-module";
import { ICombinedViewMetadata, IFormMetadata, IGridMetadata, IGridViewMetadata, IViewMetadata } from "@tylertech/tyler-api-types";
import { ResetStateService } from "../reset.state.service";

export interface AugmentedGridMetadata extends IGridMetadata
{
    $providerId?: string;
}

/* TODO: There are other dictionary properties like this that we may move, but
we should also stop following this pattern and store/use these a different way */
@Injectable({ providedIn: "root" })
export class ProviderStorageService extends ResetStateService
{
    /* For non-server-paged grids, the local full datasource for the grid to use */
    LocalEntitiesStore: Record<string, any[]> = {};

    /* For non-server-paged grids, the local filtered entities cached to prevent potentially expensive re-filtering */
    FilteredEntities: Record<string, any[]> = {};

    /* The data of the current page of the grid returned by remote service */
    GridData: Record<string, any[]> = {};

    ColumnSummaries: Record<string, Record<string, number>> = {};

    TotalHits: Record<string, number> = {};

    IsDataLoading: Record<string, boolean> = {};

    ReloadColumns: Record<string, boolean> = {};

    ClearFilter: Record<string, boolean> = {};

    ApplyFilter: Record<string, boolean> = {};

    SkipLayout: Record<string, boolean> = {};

    Refetch: Record<string, boolean> = {};

    BuildSummaries: Record<string, boolean> = {};

    InfiniteScroll: Record<string, boolean> = {};

    constructor()
    {
        super(inject(NavigationService));
    }

    IsInfiniteScroll(providerId: string): boolean
    {
        return this.InfiniteScroll[providerId];
    }

    ClearGridProviders(formMetadata: IFormMetadata): void
    {
        const self = this;
        formMetadata.Views.forEach(view => clearGridProvidersImpl(view));

        function clearGridProvidersImpl(view: IViewMetadata)
        {
            if (isCombinedView(view))
                view.Views.forEach(v => clearGridProvidersImpl(v));
            if (isGrid(view))
            {
                const providerId = view.GridProperties["$providerId"];
                delete self.LocalEntitiesStore[providerId];
                delete self.FilteredEntities[providerId];
                delete self.GridData[providerId];
                delete self.ColumnSummaries[providerId];
                delete self.IsDataLoading[providerId];
                delete self.ReloadColumns[providerId];
                delete self.ClearFilter[providerId];
                delete self.SkipLayout[providerId];
                delete self.Refetch[providerId];
                delete self.BuildSummaries[providerId];
                delete self.InfiniteScroll[providerId];

                view.GridProperties["$providerId"] = undefined;
            }
        }

        function isCombinedView(view: IViewMetadata): view is ICombinedViewMetadata
        {
            return "Views" in view;
        }

        function isGrid(view: IViewMetadata): view is IGridViewMetadata
        {
            return "GridProperties" in view;
        }
    }
}
